<template lang="html">
  <div class="col-12 col-xl-10 offset-xl-1 col-tab-2">
    <h5 class="tab-title">¿Qué es?</h5>
    <p>
      Portabilidad es el derecho que tienes como usuario de conservar tu mismo número telefónico, cuando decides cambiar de Proveedor de Servicio de Telecomunicaciones.
    </p>
    <br />
    <p>
      No importa de qué compañía de telefonía celular vengas, es muy fácil realizar tu cambio a Skycel en 24 horas* sin cambiar tu número y disfrutar de los beneficios que Skycel te ofrece:
    </p>
    <ul>
      <li>Los mejores equipos.</li>
      <li>La mayor cobertura de voz, SMS y datos.</li>
      <li>La mayor cobertura 4GLTE.</li>
    </ul>

    <p>
      Al realizar tu trámite en línea acude a un Centro de Atención a Clientes Skycel donde se te entregará tu Sim Card.
    </p>

    <br />
    <p class="text-sm">
      *De conformidad con la Regla 37 de las Reglas de Portabilidad Numérica emitidas por el Instituto Federal de Telecomunicaciones y publicadas en el Diario Oficial de la Federación con fecha 12 de noviembre de 2014, la portabilidad se llevará a cabo en un plazo máximo de 24 horas contadas a partir de que fue ingresada la solicitud, siempre y cuando esto ocurra entre las 11:00 y 17:00 horas del horario de referencia (huso horario del centro del país) en día hábil (lunes a sábado excepto días feriados). Las solicitudes presentadas en horario posterior o en día inhábil se considerarán como ingresadas a las 11:00 horas del día hábil siguiente, momento a partir del cual correrá el plazo máximo de 24 horas referido en las reglas. Más información en Centros de Atención a Clientes y Distribuidores Autorizados Skycel.
    </p>
  </div>
</template>

<script>
export default {
}
</script>
